var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3737 4.66014L7.00042 8.92314L2.62717 4.66014C2.54903 4.58382 2.44414 4.5411 2.33492 4.5411C2.22569 4.5411 2.1208 4.58382 2.04267 4.66014C2.00483 4.69721 1.97478 4.74146 1.95426 4.79029C1.93374 4.83912 1.92317 4.89155 1.92317 4.94452C1.92317 4.99748 1.93374 5.04992 1.95426 5.09875C1.97478 5.14758 2.00483 5.19182 2.04267 5.22889L6.69504 9.76489C6.77675 9.84453 6.88632 9.8891 7.00042 9.8891C7.11451 9.8891 7.22409 9.84453 7.30579 9.76489L11.9582 5.22977C11.9963 5.19267 12.0266 5.14832 12.0472 5.09933C12.0679 5.05033 12.0786 4.9977 12.0786 4.94452C12.0786 4.89134 12.0679 4.8387 12.0472 4.78971C12.0266 4.74072 11.9963 4.69636 11.9582 4.65927C11.88 4.58295 11.7751 4.54022 11.6659 4.54022C11.5567 4.54022 11.4518 4.58295 11.3737 4.65927V4.66014Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.d852469fd59375d4f7721e8e6668b48e.svg";
export { ForwardRef as ReactComponent };